<template>
  <div class="app-layout">
    <div class="app-layout-grid">
      <div class="list px-3 py-3">
        <v-card
          elevation="0"
          class="card-box-shadow mb-3"
          style="border-radius: 10px"
        >
          <v-card-title>
            <v-row no-gutters>
              <v-col cols="4">
                <h5 class="text_color--text">Sales ({{ totalCount }})</h5>
              </v-col>
              <v-col cols="4" class="text-right"> </v-col>
              <v-col class="text-right">
                <v-menu bottom :offset-y="true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      class="ml-1 rounded btn-box background_color primary--text"
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      v-if="permissions && permissions.view"
                    >
                      <v-icon small>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense v-if="permissions && permissions.view">
                    <v-list-item
                      @click="
                        showDownloadSheetDialog(
                          'Export Order Item Sheet',
                          'order',
                          'downloadOrderItemsSheet'
                        )
                      "
                    >
                      <v-list-item-title>
                        <span class="text-body-2">Export Order Item Sheet</span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="
                        showDownloadSheetDialog(
                          'Export Order Sheet',
                          'order',
                          'downloadOrderSheet'
                        )
                      "
                    >
                      <v-list-item-title>
                        <span class="text-body-2">Export Order Sheet</span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col class="text-right">
                <v-tooltip bottom :color="isButtonDisabled ? 'error' : ''">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-menu bottom :offset-y="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            class="ml-1 rounded btn-box background_color primary--text"
                            depressed
                            v-bind="attrs"
                            v-on="on"
                            :disabled="isButtonDisabled"
                            v-if="permissions && permissions.add"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item
                            @click="
                              $router.push({
                                name: 'add-delivery-sale-order',
                              })
                            "
                          >
                            <v-list-item-title>
                              <span class="text-body-2"
                                >Add Delivery Order</span
                              >
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            @click="
                              $router.push({
                                name: 'add-pickup-sale-order',
                              })
                            "
                          >
                            <v-list-item-title>
                              <span class="text-body-2">Add Pickup Order</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="openBulkUploadDialog = true">
                            <v-list-item-title>
                              <span class="text-body-2">Import Orders</span>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                  <span class="text-capitalize"> {{ buttonTooltip }} </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="d-flex py-0 app-custom-search-input">
            <v-text-field
              class="mr-1"
              label="search Order"
              prepend-inner-icon="mdi-magnify"
              outlined
              v-model="search"
              dense
              hide-details="auto"
              @keydown.enter="getOrderList(true)"
            >
            </v-text-field>
            <SalesOrdersFilter
              :filter="saleOrderFilters"
              @apply="getOrderList(true)"
              @reset="resetFilters"
              :isChips="Object.keys(saleOrderFilters).length > 0"
            />

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="h-100 btn-box background_color primary--text"
                  depressed
                  @click="getOrderList(true)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">refresh list</span>
            </v-tooltip>
          </v-card-text>
          <v-card-text style="height: 50px">
            <ChipsWithTooltip
              v-for="(value, key, index) in saleOrderFilters"
              :key="index"
              :keyToDisplay="key"
              :valueToDisplay="value"
              @remove="removeFilter(key)"
            />
          </v-card-text>
        </v-card>
        <v-card
          elevation="0"
          class="card-box-shadow overflow-y-auto app-list"
          style="
            border-radius: 10px;
            overflow-y: auto;
            height: calc(100vh - 270px);
          "
          id="order-target"
        >
          <v-expansion-panels
            v-model="orderExpansion"
            flat
            multiple
            class="background_color pr-2 app-list-card-expansion"
            v-scroll:#order-target="onOrderScroll"
          >
            <v-expansion-panel
              elevation="0"
              v-for="(order, i) in orderList"
              :key="i"
              class="px-3 py-1 ma-0 mb-2 card-box-shadow"
            >
              <OrderListCard :order="order" @selectedOrder="getOrderData" />
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </div>
      <div class="app-order-layout-grid-right">
        <OrderDetails :id="selectedOrder.id" @getList="getOrderList" />
      </div>
    </div>
    <div>
      <DownloadSheet
        v-model="openDownloadDialog"
        :title="downloadTitle"
        :module="downloadModule"
        :method="downloadMethod"
      />
      <BulkUpload
        uploadTo="sale_order"
        v-model="openBulkUploadDialog"
        @refreshList="
          checkSubscriptionLimit();
          getOrderList(true);
        "
      />
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";
import BaseCard from "@/components/BaseComponents/BaseCard.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import OrderListCard from "@/components/ModuleBasedComponents/Order/OrderListCard.vue";
import SalesOrdersFilter from "@/components/ModuleBasedComponents/Order/SaleOrder/SalesOrdersFilter.vue";
import DownloadSheet from "@/components/GeneralComponents/DownloadSheet.vue";
import BulkUpload from "@/components/BaseComponents/BulkUpload.vue";
import OrderDetails from "@/components/ModuleBasedComponents/Order/OrderDetails.vue";
import ChipsWithTooltip from "@/components/BaseComponents/ChipsWithTooltip.vue";

import { mapState } from "vuex";
import { filterModules } from "@/utils/fieldConstants";

export default {
  components: {
    BaseCard,
    GoogleMap,
    MapInfo,
    OrderListCard,
    SalesOrdersFilter,
    BulkUpload,
    DownloadSheet,
    OrderDetails,
    ChipsWithTooltip,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      permissions: null,
      orderExpansion: [0],
      orderList: [],
      statusList: [
        "Unassigned",
        "Assigned",
        "Cancelled",
        "Not Delivered",
        "Not Pickedup",
        "Picked up",
        "Out For Delivery",
        "Delivered",
        "Partially Delivered",
      ],
      openBulkUploadDialog: false,
      orderDetail: {},
      search: null,
      selectedRoute: null,
      headers: [
        {
          value: "reference_number",
          align: "start",
          text: "Reference Number",
        },
        {
          value: "status",
          align: "start",
          text: "Status",
        },
        {
          value: "order_type",
          align: "start",
          text: "Order Type",
        },
        {
          value: "total_quantity",
          align: "start",
          text: "Total Quantity",
        },
        {
          value: "volume",
          align: "start",
          text: "Volume",
        },
        {
          value: "weight",
          align: "start",
          text: "Weight",
        },
        {
          value: "address",
          align: "start",
          text: "Address",
        },
      ],

      downloadModule: null,
      downloadMethod: null,
      downloadTitle: "",
      openDownloadDialog: false,
      totalCount: 0,
      isOrderListScrollable: true,
      selectedOrder: {},

      isButtonDisabled: false,
      buttonTooltip: "Add Sale Orders",
    };
  },
  computed: {
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
    ...mapState("userProfile", {
      saleOrderFilters: (state) => state.sale_order_filters,
    }),
  },
  methods: {
    checkSubscriptionLimit() {
      this.$api.company
        .checkSubscriptionLimit(this.profileObject.company, {
          module: "order",
        })
        .then(() => {
          this.isButtonDisabled = false;
          return true;
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.data.non_field_errors[0],
            color: "error",
            timeout: 4000,
          });
          this.isButtonDisabled = true;
          this.buttonTooltip = err.data.non_field_errors[0];
          return false;
        });
    },
    onOrderScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isOrderListScrollable) {
        this.isOrderListScrollable = false;
        this.getOrderList();
      }
    },
    showDownloadSheetDialog(title, module, method) {
      this.downloadModule = module;
      this.downloadMethod = method;
      this.downloadTitle = title;
      this.openDownloadDialog = true;
    },
    getOrderData(order) {
      this.selectedOrder = order;
    },
    setOrderLocationOnMap(data) {
      setTimeout(() => {
        this.$refs.orderMap.clearMarker();
        data.drop_details.title = "order details";
        this.$refs.orderMap.setCustomMaker(data.drop_details, "source");
      }, 200);
    },
    getOrderDetail(id) {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderView(id)
        .then((res) => {
          this.orderDetail = res.data;
          this.setOrderLocationOnMap(res.data);
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    removeFilter(key) {
      this.$store.commit("userProfile/removeFilter", {
        moduleKey: "sale_order_filters",
        filterKey: key,
      });
      this.getOrderList(true);
    },
    resetFilters() {
      this.$store.commit("userProfile/resetFilters", {
        moduleKey: "sale_order_filters",
      });
      this.getOrderList(true);
    },
    showDownloadSheetDialog(title, module, method) {
      this.downloadModule = module;
      this.downloadMethod = method;
      this.downloadTitle = title;
      this.openDownloadDialog = true;
    },
    async getOrderList(reload, params = {}) {
      params = {
        ...params,
        offset: reload ? 0 : this.orderList.length,
        limit: 20,
        ...this.saleOrderFilters,
      };
      await this.$store.dispatch("userProfile/updateUserFilters", {
        filter_data: { ...this.saleOrderFilters },
        filter_type: filterModules.SALE_ORDER,
      });

      if (this.search) {
        params.search = this.search;
      }

      // if ("ordering" in params && params.ordering.length > 0) {
      //   params = { ...params, ordering: params.ordering };
      // }

      if (params && params.status) {
        params.status = params.status.join(",");
      }

      if (reload || this.totalCount != this.orderList.length) {
        bus.$emit("showLoader", true);
        this.$api.saleOrder
          .getOrderList(params)
          .then((res) => {
            bus.$emit("showLoader", false);
            if (reload) {
              this.orderList = res.data;
            } else {
              this.orderList = [...this.orderList, ...res.data];
            }
            this.totalCount = res.count;
            if (this.totalCount != this.orderList.length) {
              this.isOrderListScrollable = true;
            }
          })
          .catch((err) => {
            console.log(err);
            bus.$emit("showLoader", false);
          });
      }
    },
  },
  async mounted() {
    if (this.data && this.data.id) {
      this.search = this.data.reference_number;
      this.getOrderData(this.data.id);
      await this.getOrderList(true);
    } else {
      await this.getOrderList(true);
    }
  },
  created() {
    this.permissions = this.$permissions.getPermission("order");

    this.checkSubscriptionLimit();
  },
};
</script>

<style>

.app-order-layout {
  position: absolute;
  height: 100%;
  width: 100%;
}
.app-order-layout-grid {
  display: grid;
  grid-template-columns: 350px 1fr;
  height: 100%;
  width: 100%;
}
.app-order-layout-grid-left {
  display: grid;
  grid-template-rows: 180px 1fr;
}
.app-order-layout-grid-right {
  display: flex;
  height: 100%;
  width: 100%;
}
.v-expansion-panel-header {
  min-height: 30px !important;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 3;
}
</style>
